import {
	EXPAND_BUTTON_WIDTH,
	EXPAND_CELL_PADDING,
	CREATE_CHILD_BUTTON_WIDTH,
	DEPTH_WIDTH,
} from '../../common/constants.tsx';

export const getExpandColumnWidth = (depth: number) =>
	depth * DEPTH_WIDTH + EXPAND_BUTTON_WIDTH + CREATE_CHILD_BUTTON_WIDTH + EXPAND_CELL_PADDING;
